import Search from "../Search";


interface IFilterProps {
    open: boolean;
    onClose: () => void;
    onChange: () => void;
    value: string;
}


const Filter: React.FC<IFilterProps> = ({
    open, 
    onClose,
    onChange,
    value
}) => {
    return <Search
        open={open}
        handleClose={onClose}
        handleChange={onChange}
        value={value}
    />;
}


export default Filter;